
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bai-viet/danh-muc/[id]",
      function () {
        return require("private-next-pages/bai-viet/danh-muc/[id]/index.page.tsx");
      }
    ]);
  